<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DfmDHw/tc-custom/9781466882638.jpg?1725723386508" alt="This image is the cover for the book Violinist of Venice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Violinist of Venice
      </h1>
      <p class="bookDescription body article font2">
        <p>Like most 18th century Venetians, Adriana d'Amato adores music—except her strict merchant father has forbidden her to cultivate her gift for the violin. But she refuses to let that stop her from living her dreams and begins sneaking out of her family's palazzo under the cover of night to take violin lessons from virtuoso violinist and composer Antonio Vivaldi. However, what begins as secret lessons swiftly evolves into a passionate, consuming love affair.<br/><br/>Adriana's father is intent on seeing her married to a wealthy, prominent member of Venice's patrician class—and a handsome, charming suitor, whom she knows she could love, only complicates matters—but Vivaldi is a priest, making their relationship forbidden in the eyes of the Church and of society. They both know their affair will end upon Adriana's marriage, but she cannot anticipate the events that will force Vivaldi to choose between her and his music. The repercussions of his choice—and of Adriana's own choices—will haunt both of their lives in ways they never imagined.<br/><br/>Spanning more than 30 years of Adriana's life, Alyssa Palombo's <i>The Violinist of Venice</i> is a story of passion, music, ambition, and finding the strength to both fall in love and to carry on when it ends.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alyssa Palombo
      </h2>
      
      <p class="authorDescription body article">ALYSSA PALOMBO has published short historical fiction pieces in <I>Black Lantern</I>, <I>Novelletum</I>, and <I>The Great Lakes Review</I>. She is a recent a graduate of Canisius College with degrees in English and creative writing, respectively, as well as a trained classical musician. The Violinist of Venice is her first novel. She lives in Tonawanda, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35c7ff46